<template>
  <div class="modal custom-modal fade" :id="modalId" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Sil</h3>
            <p>Silmək istədiyinizə əminsiniz?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" @click="confirmDelete" class="btn btn-primary continue-btn"
                  >Sil</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-primary cancel-btn"
                  >Ləğv et</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps,defineEmits } from 'vue';

const props = defineProps(['modalId']);

const emit = defineEmits(['deleteConfirmed']);

const confirmDelete = () => {
  emit('deleteConfirmed');
};

</script>
